import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const Brand = ({ content }) => {
    return (
        <Chip id="260720" title="权益图片" groupName="中国力量" type="struct">
            <div className={styles.brand}>
                {content.url ? (
                    <a href={content.url} target="_blank" rel="noreferrer">
                        <img src={content.imageUrl} />
                    </a>
                ) : (
                    <img src={content.imageUrl} />
                )}
            </div>
        </Chip>
    );
};

Brand.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Brand);
